/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  "'Goals.CreateGoal.footer.create-label": 'Crear',
  'Goals.CreateGoal.create.error': 'Error al crear la meta',
  'Goals.CreateGoal.create.network.error': 'Error en la conexión',
  'Goals.CreateGoal.create.permission.error': 'No tienes el permiso necesario para crear una meta.',
  'Goals.CreateGoal.error.description': 'Algo ha ido mal, comprueba tu conexión a Internet e inténtalo de nuevo.',
  'Goals.CreateGoal.error.header': 'Error al crear la meta',
  'Goals.CreateGoal.footer.cancel-label': 'Cancelar',
  'Goals.CreateGoal.form.icon.back-button-label': 'Atrás',
  'Goals.CreateGoal.form.name.error': 'Debes proporcionar un nombre de meta',
  'Goals.CreateGoal.form.name.label': 'Nombre',
  'Goals.CreateGoal.form.owner.error': 'El propietario no puede estar en blanco.',
  'Goals.CreateGoal.header': 'Crear meta',
  'Goals.CreateGoal.parent-goal-label': 'Meta principal',
  'Goals.CreateGoal.parent-goal.error': 'La meta principal no puede estar en blanco.',
  'Goals.CreateGoal.required-fields-are-marked':
    'Los campos obligatorios están marcados con un asterisco <asterisk></asterisk>',
  'Goals.CreateGoal.site-label': 'Sitio',
  'Goals.CreateGoal.type-label': 'Tipo',
  'Goals.CreateGoal.type-label-placeholder': '¿Cómo deberíamos llamarlo?',
  'Goals.GoalCreationModal.label.date-selection-placeholder': 'Seleccionar fecha',
  'Goals.GoalCreationModal.label.date-selection-title': 'Fecha prevista',
  'Goals.GoalCreationModal.label.owner-picker-placeholder': 'Introducir una persona',
  'Goals.GoalCreationModal.label.owner-selection-title': 'Propietario',
  'townsquare.api.goal-type-description.goal': 'Metas para cualquier propósito',
  'townsquare.api.goal-type-description.key-result':
    'La forma cuantitativa de medir un objetivo (marco de objetivos y resultados clave).',
  'townsquare.api.goal-type-description.objective':
    'Resultado que quieres obtener (marco de Objetivos y resultados clave)',
};
